<div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 mr-12 p-0 m-r-6 m-b-6'">

  <div class="title-height" fxLayout="row" fxLayoutAlign="space-between center">
    <div class="h3 pr-16 cardHeader">Bajas</div>
    <div>
      <button mat-icon-button *ngIf="sharedService.Permissions.HasPermisos602 || sharedService.Permissions.HasPermisos601"
        [routerLink]="['/employee/create-leave', EmployeeId, LeaveOperations.NewLeave]">
          <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">add</mat-icon>
      </button>
    </div>
  </div>
  <div class="p-10 pt-0">
    <table class="table table-striped w100">
      <caption></caption>
      <thead>
        <tr>
          <th id="">Tipo</th>
          <th id="">Fechas</th>
          <th id="" class="numeric-column">Días</th>
          <th id="">NJ</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let leave of leaveService.LeaveList" class="pointer m-t-7" (click)="OnEmployeeLeaveSelect(leave.Id)"
          [className]="leaveService.SelectedRowId===leave.Id ?'highlightRow':'normalRow'">

          <td>{{leave.Tipo }}</td>
          <td>
            <span>{{leave.FBaja | date: 'dd/MM/yyyy'}}</span>
            <span *ngIf="leave.FAlta != null"> ... {{leave.FAlta | date: 'dd/MM/yyyy'}}</span>
          </td>
          <td class="numeric-column">{{leave.Dias}}</td>
          <td>
            <span *ngIf="leave.Nj == 'N'">
              <span class="dot"></span>
            </span>
            <span *ngIf=" leave.Nj != 'N'"></span>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="leaveService.IsLeavesLoading" class="m-auto">
      <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
      </mat-progress-spinner>
    </div>
  </div>

</div>